import { showHeaderOverlay, hideHeaderOverlay } from 'Functions/overlay'
import { checkResolution } from 'Functions/helpers'
import { calculateHeaderSize } from 'Functions/window'
import 'Ui/tabs'
import 'Components/navigation-menu-aim'

const aside = {
    trigger: document.querySelector('.js-aside-trigger'),
    targets: document.querySelectorAll('.js-header-navigation'),
    toggle() {
        if (this.trigger.classList.contains('is-active')) {
            this.close()
        } else {
            this.open()
        }
    },
    open() {
        this.trigger.classList.add('is-active')
        this.targets.forEach(target => {
            target.classList.add('is-active')
        })
        showHeaderOverlay('nav-aside')
        calculateHeaderSize();
        document.addEventListener('click', this.handleClickOutside.bind(this))
    },
    close() {
        this.trigger.classList.remove('is-active')
        this.targets.forEach(target => {
            target.classList.remove('is-active')
        })
        hideHeaderOverlay('nav-aside')
        document.removeEventListener('click', this.handleClickOutside.bind(this))
    },
    handleClickOutside(event) {
        const targetEvent = event.target;

        if (!checkResolution('lg') && !this.trigger.contains(targetEvent)) {
            let close = true;

            this.targets.forEach(target => {
                if (target.contains(targetEvent)) {
                    close = false;
                }
            })

            if (close) {
                this.close()
            }
        }
    }
}

if (aside.trigger) {
    aside.trigger.addEventListener('click', event => {
        aside.toggle()
    })
}